import { render, staticRenderFns } from "./ProductsManage.html?vue&type=template&id=87ef1728&external"
import script from "./ProductsManage.js?vue&type=script&lang=js&external"
export * from "./ProductsManage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports